module.exports = __webpack_public_path__ + "static/infrastructure-a08086fab98182f734cc3b6f88114fa2.jpg";